export const DEFINE_MODULE = {
  name: "giáo viên",
  fields: "availability",
}
